// extracted by mini-css-extract-plugin
export default {"title":"wIgrM","editionTitle":"_1WIxb","group":"_3MmQG","molotovPayBox":"_3VxZX","info":"XyBg4"};